import { listenEbene } from "./listenEbenen";

/**
 * listenStart.ts — Startnummer einer Nummerierung (T-347).
 *
 * Melderin: „Hier muss ich z. B. aus der 1. eine 2. machen" — Punkt 1 stand
 * weiter oben in der Mail, getrennt durch eine Tabelle. Wie in Word/Outlook
 * gibt es dafür zwei Wege: „2. " tippen (`listenTasten.ts`) oder per Rechtsklick
 * „Nummerierung beginnen bei …" bzw. „Nummerierung fortsetzen" (`RichTextEditor`).
 *
 * Getragen wird die Nummer vom HTML-Attribut `start` am `<ol>` — das werten
 * alle Mailprogramme aus. Der Server-Sanitizer lässt es seit T-347 durch.
 */

/** Startnummer einer Liste (fehlendes/ungültiges `start` = 1). */
export function listenStart(ol: HTMLOListElement | HTMLElement): number {
    const roh = ol.getAttribute("start");
    const n = roh == null ? NaN : parseInt(roh, 10);
    return Number.isFinite(n) ? n : 1;
}

/** Setzt die Startnummer; `n <= 1` entfernt das Attribut (Standard bleibt sauber). */
export function setzeListenStart(ol: HTMLElement, n: number): void {
    const zahl = Math.floor(n);
    if (!Number.isFinite(zahl) || zahl <= 1) ol.removeAttribute("start");
    else ol.setAttribute("start", String(zahl));
}

/** Anzahl der eigenen Punkte einer Liste (ohne die verschachtelter Unterlisten). */
function anzahlPunkte(ol: Element): number {
    let n = 0;
    for (const kind of Array.from(ol.children)) if (kind.tagName === "LI") n++;
    return n;
}

/**
 * Die Nummerierung, die `ol` fortsetzen würde: die letzte `<ol>` DAVOR im
 * Editor auf derselben Ebene — nicht eine, in der `ol` steckt, und nicht eine
 * in ihr. `null`, wenn es keine gibt.
 */
export function vorherigeNummerierung(root: HTMLElement, ol: HTMLElement): HTMLElement | null {
    const ebene = listenEbene(ol, root);
    let treffer: HTMLElement | null = null;
    for (const kandidat of Array.from(root.querySelectorAll<HTMLElement>("ol"))) {
        if (kandidat === ol) break; // Dokumentreihenfolge: alles danach zählt nicht
        if (kandidat.contains(ol)) continue;
        if (listenEbene(kandidat, root) !== ebene) continue;
        treffer = kandidat;
    }
    return treffer;
}

/** Startnummer, mit der `ol` die vorherige Nummerierung fortsetzt — oder `null`. */
export function fortsetzungsStart(root: HTMLElement, ol: HTMLElement): number | null {
    const vorher = vorherigeNummerierung(root, ol);
    if (!vorher) return null;
    return listenStart(vorher) + anzahlPunkte(vorher);
}

/** „Nummerierung fortsetzen". Gibt zurück, ob es eine vorherige Liste gab. */
export function nummerierungFortsetzen(root: HTMLElement, ol: HTMLElement): boolean {
    const start = fortsetzungsStart(root, ol);
    if (start == null) return false;
    setzeListenStart(ol, start);
    return true;
}
